import Footer from './Footer'
import LinkToKickStartVideos from './LinkToKickStartVideos'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'

const KickStartFooter = () =>
  <Footer Icon={<span>🚀</span>}>
    <Paragraph>
      <Color
        display='inline'
        variant='theme-description-text'
      >
        Get started with a tutorial in {' '}<LinkToKickStartVideos>KickStart Testing</LinkToKickStartVideos>.
      </Color>
    </Paragraph>
  </Footer>

export default KickStartFooter
